import styled from 'styled-components';

export const SmallText = styled.p`
  color: #3b455a;
  font-size: 12px;
  line-height: 1.5;
  font-weight: 400;
`;

export const NormalText = styled.p`
  color: #3b455a;
  font-size: 14px;
  line-height: 1.5;
  font-weight: 400;
`;

export const MediumText = styled.p`
  color: #363636;
  font-size: 16px;
  line-height: 1.5;
  font-weight: 400;
`;
